module.exports = __webpack_public_path__ + "static/media/ico-search.97b44363.svg";